import { css } from "lit";

export const notificationBellStyles = css`
  :host {
    display: inline-flex;
    position: relative;
  }

  .bell-container {
    position: relative;
    cursor: pointer;
    border-radius: 8px;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bell-container:hover {
    background-color: var(--sds-color-background-default-hover);
  }

  .bell-container:active {
    transform: scale(0.95);
  }

  .badge {
    position: absolute;
    bottom: 14px;
    left: 14px;
    display: flex;
    width: 13px;
    height: 13px;
    padding: 1px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 8px;
    background: var(--sds-color-background-danger-default);

    color: #fff;
    font-family: var(--sds-typography-family-body);
    font-size: 10px;
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%;
  }

  ph-bell-simple {
    font-size: 20px;
    color: var(--sds-color-text-default-default);
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
